var pug = require("!./../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"wrapper\"\u003E\u003Ch1\u003Eハイライト編集UI\u003C\u002Fh1\u003E\u003Cdiv class=\"content-wrapper\"\u003E\u003Ch2\u003E確認画面\u003C\u002Fh2\u003E\u003Cdiv class=\"js-textSelector textbox\"\u003Eある日の暮方の事である。一人の下人げにんが、羅生門らしょうもんの下で雨やみを待っていた。広い門の下には、この男のほかに誰もいない。ただ、所々丹塗にぬりの剥はげた、大きな円柱まるばしらに、蟋蟀きりぎりすが一匹とまっている。羅生門が、朱雀大路すざくおおじにある以上は、この男のほかにも、雨やみをする市女笠いちめがさや揉烏帽子もみえぼしが、もう二三人はありそうなものである。それが、この男のほかには誰もいない。\u003C\u002Fdiv\u003E\u003Cul class=\"tags\"\u003E\u003C\u002Ful\u003E\u003Cbutton class=\"button button-textSelector js-change-mode\" data-mode-input=\"true\"\u003EEdit\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


/*****************
 ** WEBPACK FOOTER
 ** ./app/posts/idea01.pug
 ** module id = 181
 ** module chunks = 0
 **/